import React, { useState } from "react";
import { Download } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { downloadPdf } from "./FileUpload";
import { Button } from "./ui/button";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const money = (v) => (v ? `$${Number(v).toFixed(2)}` : "—");

export function MonthlyAccountSummary() {
  const [year, setYear] = useState(new Date().getFullYear());
  const { data } = useApi(`/admin/reports/monthly-by-account?year=${year}`, [year]);
  const cols = data?.accounts || [];
  return (
    <div className="mt-10" data-testid="monthly-account-summary">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-serif-display text-xl font-bold text-crimson">Monthly income by account · {year}</h3>
        <div className="flex gap-1">
          <Button size="sm" variant="outline" onClick={() => setYear(year - 1)} data-testid="monthly-prev-year">‹ {year - 1}</Button>
          <Button size="sm" variant="outline" onClick={() => setYear(year + 1)} data-testid="monthly-next-year">{year + 1} ›</Button>
          <Button size="sm" variant="outline" className="ml-2 gap-1" data-testid="monthly-export"
            onClick={() => downloadPdf(`/admin/reports/monthly-by-account.csv?year=${year}`, `income-by-account-${year}.csv`)}><Download size={14} /> CSV</Button>
        </div>
      </div>
      <div className="mt-3 glass overflow-x-auto rounded-2xl">
        <table className="w-full text-sm" data-testid="monthly-table">
          <thead className="bg-crimson text-parchment"><tr>
            <th className="p-3 text-left">Month</th>
            {cols.map((a) => <th key={a} className="p-3 text-right">{a}</th>)}
            <th className="p-3 text-right">Total</th></tr></thead>
          <tbody>
            {(data?.months || []).map((r, i) => (
              <tr key={r.month} className="border-b border-gold/15" data-testid={`monthly-row-${r.month}`}>
                <td className="p-3">{MONTHS[i]}</td>
                {cols.map((a) => <td key={a} className="p-3 text-right font-mono-accent">{money(r[a])}</td>)}
                <td className="p-3 text-right font-mono-accent font-semibold">{money(r.total)}</td>
              </tr>
            ))}
            {data && (
              <tr className="bg-gold-light/60 font-semibold" data-testid="monthly-totals">
                <td className="p-3">Year total</td>
                {cols.map((a) => <td key={a} className="p-3 text-right font-mono-accent">{money(data.totals[a])}</td>)}
                <td className="p-3 text-right font-mono-accent">{money(data.totals.total)}</td>
              </tr>
            )}
            {data && cols.length === 0 && <tr><td className="p-3 text-muted-foreground" colSpan={2}>No confirmed payments in {year}.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
